import { render, staticRenderFns } from "./supplierProducts.vue?vue&type=template&id=2a859a39&scoped=true&"
import script from "./supplierProducts.vue?vue&type=script&lang=js&"
export * from "./supplierProducts.vue?vue&type=script&lang=js&"
import style0 from "./supplierProducts.vue?vue&type=style&index=0&id=2a859a39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a859a39",
  null
  
)

export default component.exports